<template>
  <div>
    <div v-if="isValid">
      <div class="flex justify-between ma-5">
        <select v-model="year" @change="fetchRouteTickets">
          <option value="2023">2023</option>
          <option value="2024">2024</option>
        </select>
        <select v-model="month" @change="fetchRouteTickets">
          <option value="1">Yanvar</option>
          <option value="2">Febral</option>
          <option value="3">Mart</option>
          <option value="4">Aprel</option>
          <option value="5">May</option>
          <option value="6">Iyun</option>
          <option value="7">Iyul</option>
          <option value="8">Avgust</option>
          <option value="9">Sentyabr</option>
          <option value="10">Oktyabr</option>
          <option value="11">Noyabr</option>
          <option value="12">Dekabr</option>
        </select>
      </div>

      <div class="flex justify-center" v-show="!loading">
        <table class="w-full mx-5">
          <tr class="font-bold bg-gray-200">
            <td colspan="7">ТЧ-2 Коканд</td>
          </tr>
          <tr>
            <td colspan="3" class="text-start">Сотрудник</td>
            <td colspan="4" class="font-bold text-start">
              {{ routeTicket.client.full_name }}
            </td>
          </tr>
          <tr>
            <td colspan="3" class="text-start">Таб.номер</td>
            <td colspan="4" class="font-bold text-end">
              {{ routeTicket.client.number }}
            </td>
          </tr>
          <tr>
            <td colspan="3" class="text-start">Месяц начислений</td>
            <td colspan="4" class="font-bold text-start">
              {{ routeTicket.date }}
            </td>
          </tr>

          <tr class="font-bold bg-gray-200">
            <td colspan="4">Итого</td>
            <td colspan="1">Отр часы</td>
            <td colspan="1">Км</td>
          </tr>
          <tr v-for="item of routeTicket.route_tickets.total" :key="item.type">
            <td colspan="4" class="text-start">
              {{ item.type.substr(0, 25) }}
            </td>
            <td colspan="1" class="text-end">
              {{ item.hour | money_humanize }}
            </td>
            <td colspan="1" class="text-end">
              {{ item.long | money }}
            </td>
          </tr>

          <tr class="font-bold bg-gray-200">
            <td>N</td>
            <td>Дата маршрут</td>
            <td>Номер локо</td>
            <td>Серия локо</td>
            <td>Отр часы</td>
            <td>Км</td>
          </tr>
          <tr
            v-for="(ticket, seq) of routeTicket.route_tickets.tickets"
            :key="seq"
          >
            <td>{{ seq + 1 }}</td>
            <td>{{ ticket.ticket_date }}</td>
            <td class="text-end">{{ ticket.machine_number }}</td>
            <td class="text-start">{{ ticket.machine_series }}</td>
            <td class="text-end">{{ ticket.hour | money_humanize }}</td>
            <td class="text-end">{{ ticket.long | money_humanize }}</td>
          </tr>
        </table>
      </div>

      <div class="flex justify-center items-center h-[500px]">
        <div v-show="loading">
          <svg
            class="w-40 h-40 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      </div>
    </div>

    <div v-else class="flex justify-center items-center h-screen">
      <span class="text-lg">Unauthorized...</span>
    </div>
  </div>
</template>

<script>
import api from "../../axios";
const { VUE_APP_BASIC_USERNAME, VUE_APP_BASIC_PASSWORD } = process.env;
const tg = window.Telegram.WebApp;

export default {
  name: "TelegramRouteTicket",
  data: () => ({
    loading: true,
    year: null,
    month: null,
    routeTicket: {
      client: {
        id: -1,
        full_name: "",
      },
      date: "",
      route_tickets: {
        tickets: [],
        total: [],
      },
    },
  }),
  created() {
    this.init();
    this.fetchRouteTickets();
  },
  methods: {
    init() {
      if (this.$route.query?.year) {
        this.year = this.$route.query.year;
      } else {
        this.year = new Date().getFullYear();
      }
      if (this.$route.query?.month) {
        this.month = this.$route.query.month;
      } else {
        this.month = new Date().getMonth() + 1;
      }
    },
    async fetchRouteTickets() {
      try {
        this.loading = true;

        const { data } = await api.post(
          "/route-tickets/get-client-tickets",
          {
            init_data: tg?.initData || "asdfas",
            chat_id: tg?.initDataUnsafe?.user?.id || "622807196",
            date:
              this.year +
              "-" +
              (this.month < 9 ? `0${this.month}` : this.month) +
              "-01",
          },
          {
            auth: {
              username: VUE_APP_BASIC_USERNAME,
              password: VUE_APP_BASIC_PASSWORD,
            },
          }
        );

        this.routeTicket.date = data.data?.date;
        this.routeTicket.client = data.data?.client;
        this.routeTicket.route_tickets.tickets =
          data.data?.route_tickets?.tickets;
        this.routeTicket.route_tickets.total = data.data?.route_tickets?.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    isValid: {
      get: () => !!tg?.initData,
    },
  },
};
</script>

<style scoped>
table {
  font-size: 10px;
}

td,
th {
  border: 1px solid black;
  text-align: center;
  padding: 0 5px;
}

select {
  background-color: #eaeaea;
  border-radius: 6px;
  padding: 3px;
  text-align: center;
  width: 150px;
  border: 1px solid #e8eaed;
}
</style>
